import { useFleet } from '../state/store'
import type { MbmtStatusEvent } from '../lib/types'

export type { MbmtStatusEvent }

/** vehicle_id -> latest live status, from the SAME shared /events SSE connection the
 *  general fleet and the Nagpur bus board already use (serving/app.py's
 *  _publish/subscribers) -- genuinely the one connection now, not a second one that
 *  happened to share a comment saying so: this used to open its own `new
 *  EventSource('/events')`, a real second connection to the same endpoint
 *  useFleetData.ts already holds open for every signed-in session regardless of which
 *  site route is active (AppShell.tsx's Console() calls useFleetData() once, above every
 *  site's <Route>). CLAUDE.md's live-data section is explicit that a second EventSource
 *  is not an acceptable way to add a message type -- the event is handled in
 *  store.ts's applyEvent switch ('mbmt_status') instead, and this hook is now just a
 *  selector over that state. Mirrors useBusStatusEvents.ts's own fix exactly. */
export function useMbmtStatusEvents(): Record<string, MbmtStatusEvent> {
  return useFleet((s) => s.mbmtStatus)
}
